/**
 * CoZzzy overrides for Shopify.actions (standard actions):
 * - updateCart: emit events from the CoZzzy side cart.
 * - openCart: open the CoZzzy side cart (there is no cart page anymore).
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('#CzCart') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      if (window.CzCart) {
        await window.CzCart.refresh();
        window.CzCart.open();
      } else {
        window.location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
